module.exports = __webpack_public_path__ + "img/svg/step5.aae32286a81fea15843d1bfcc04acb0c.svg";